import { getValidationLogic } from './getValidationLogic'

const withdraw = (role: 'admin' | 'advertiser' | 'publisher') => {
  return {
    amount: {
      presence: {
        allowEmpty: getValidationLogic('transaction', 'withdraw', 'amount', 'allowEmpty', 'default'),
        message: '^inputError.requiredField'
      },
      format: {
        greaterThanOrEqualTo: Number(
          getValidationLogic('transaction', 'withdraw', 'amount', 'greaterThanOrEqualTo', role)
        ),
        notGreaterThanOrEqualTo: '^inputError.notGreaterThanOrEqualTo',
        lessThanOrEqualTo: Number(getValidationLogic('transaction', 'withdraw', 'amount', 'lessThanOrEqualTo', role)),
        notLessThanOrEqualTo: '^inputError.notLessThanOrEqualTo'
      }
    }
  }
}

export default withdraw
